import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './UserManagement.css';
import AddUserForm from '../components/AddUserForm'; // import at the top

export default function UserManagement() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');

  const fetchUsers = async () => {
    try {
      const response = await axios.get('http://localhost:5000/api/users');
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching users:', error.message);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const filteredUsers = users.filter(user =>
    user.name?.toLowerCase().includes(search.toLowerCase()) ||
    user.email?.toLowerCase().includes(search.toLowerCase())
  );
  const handleDeactivate = async (id) => {
  if (window.confirm("Are you sure you want to deactivate this user?")) {
    try {
      await axios.post(`http://localhost:5000/api/users/deactivate/${id}`);
      fetchUsers(); // Refresh user list
    } catch (error) {
      console.error('Error deactivating user:', error.message);
    }
  }
};


  return (
    <div className="user-management">
      <h2>User Management</h2>
      <input
        type="text"
        placeholder="Search by name or email..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
        <AddUserForm onUserAdded={fetchUsers} />
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Verified</th>
            <th>Created At</th>
          </tr>
        </thead>
        <tbody>
  {filteredUsers.map(user => (
    <tr key={user.id}>
      <td data-label="Name">{user.name}</td>
      <td data-label="Email">{user.email}</td>
      <td data-label="Mobile">{user.mobile}</td>
      <td data-label="Verified">{user.is_verified ? 'Yes' : 'No'}</td>
      <td data-label="Created At">{new Date(user.created_at).toLocaleDateString()}</td>
      <td>
        <button onClick={() => handleDeactivate(user.id)}>Deactivate</button>
      </td>
    </tr>
  ))}
</tbody>
      </table>
    </div>
  );
}
